const style = (theme) => {
  const output = {
    root: {
      marginBottom: 30,
    },
    image: {
      position: 'relative',
      zIndex: 1,
      width: 200,
      height: 200,
      margin: '0 auto',
      backgroundColor: theme.colors[3],
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        width: '70%',
        height: 'auto',
      },
      '& svg': {
        width: '50%',
        fill: theme.colors[3],
      },
    },
    order: {
      position: 'absolute',
      top: '5%',
      right: '5%',
      zIndex: 1,
      width: 40,
      height: 40,
      backgroundColor: theme.colors[2],
      color: theme.colors[1],
      fontSize: 15,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
    },
    rootColorLight: {
      '& $image': {
        backgroundColor: theme.colors[1],
      },
    },
    info: {
      marginTop: 25,
      '& p': {
        width: 250,
        margin: '0 auto',
        textAlign: 'center',
        fontSize: 16,
      },
    },
  }

  return output
}

export default style
